import {useQueries} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {ROUTE_PATHS} from '@di-shared/routes';
import {emitEventLog} from '@di-shared/features/analytics';

function useOpenChargingHabitBottomSheet({vin, puid}: {vin: string; puid: string}) {
  /**
   * 홈화면 > EV 배터리 (EV BaaS 기능) 중에서 '충전 습관' 카드 컴포넌트를 클릭하면 띄우는 바텀시트를 위한 기능
   * 1. 바텀시트에 vin과 puid를 넘기고 바텀시트에서 getEvChargeHistory call
   * 2. getEvChargeHistory > chargedDays를 받아서 바텀시트에 넘기기 (채택)
   * 각각의 카드들은 해당 카드에서 쓰이는 api가 fail이면 표출하지 않는다.
   * 영역의 카드들이 전부 fail이면 '분석중...' 카드가 뜨게 된다.
   * -> 이런 기능 때문에 각각의 카드에서 api call + ErrorBoundary + useErrorCounter 를 사용
   * getEvChargeHistory를 사용하지 않는 카드에서도 getEvChargeHistory > chargedDays를 넘기기 위해 해당 훅 만듬
   */
  const [historyData, summaryData] = useQueries({
    queries: [
      {
        queryKey: [getQueryKey(diApi.evBatteryController.getEvChargeHistory), vin, puid],
        queryFn: () => diApi.evBatteryController.getEvChargeHistory({vin, puid}),
        throwOnError: false,
      },
      {
        queryKey: [getQueryKey(diApi.evBatteryController.getEvChargeSummary), vin, puid],
        queryFn: () => diApi.evBatteryController.getEvChargeSummary({vin, puid}),
      },
    ],
  });

  async function openChargingHabitBottomSheet() {
    if (historyData.isLoading || historyData.isError || summaryData.isLoading || summaryData.isError) {
      return;
    }
    emitEventLog({
      event: 'vehicle_status_check',
      interaction_type: 'ev_charging_habit',
    });
    await ccWebviewUtils.openBottomSheetWebViewUrl(ROUTE_PATHS.BOTTOM_SHEET_DIAG_BATTERY_CHARGING_HABIT.getFullPath(), {
      chargedDays: historyData.data?.data?.chargedDays,
      summaryData: summaryData.data?.data,
    });
  }

  return {openChargingHabitBottomSheet};
}

export default useOpenChargingHabitBottomSheet;
